import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'logzy-quote-acceptance',
  templateUrl: './quote-acceptance.component.html',
  styleUrls: ['./quote-acceptance.component.scss']
})
export class QuoteAcceptanceComponent implements OnInit {

  basic: string = "100%";
  loader: boolean = false;
  expand: boolean = false;
  quoteAccepted: boolean = false;
  tableData = [
    {
      colhead: 'Quantity',
      coldata: '400'
    },
    {
      colhead: 'Free Days',
      coldata: '10 / 20'
    },
    {
      colhead: 'Per Diem Charge',
      coldata: '$10.00 / $20.00 USD'
    },
    {
      colhead: 'Pick-Up Charge',
      coldata: '$10.00 USD'
    },
    {
      colhead: 'Drop-Off Charge',
      coldata: '$10.00 USD'
    },
    {
      colhead: 'DPP Charge',
      coldata: '$10.00 USD'
    },
    {
      colhead: 'Storage Charge',
      coldata: '$10.00 USD'
    },
    {
      colhead: 'Cancellation Charge',
      coldata: '$10.00 USD'
    },
    {
      colhead: 'Depreciation',
      coldata: '5.00%'
    },
    {
      colhead: 'Minimum Replacement Value',
      coldata: '$50.00 USD'
    },
    {
      colhead: 'Maximum Depreciation',
      coldata: 'None%'
    },
    {
      colhead: 'Insurance',
      coldata: 'I will take Risk.'
    },

  ]
  acceptQuote(a) {
    this.quoteAccepted = a;
  }
  constructor() { }

  ngOnInit(): void {
  }

}
